var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace5Stars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.24,
    height: 56.24,
    viewBox: "0 0 56.24 56.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face-5-stars",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_62573",
    "data-name": "Path 62573",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.24,31.12A28.12,28.12,0,1,1,31.12,3,28.12,28.12,0,0,1,59.24,31.12Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.12000274658203 53.23999786376953 C 43.3170166015625 53.23999786376953 53.2400016784668 43.31700897216797 53.2400016784668 31.12001037597656 C 53.2400016784668 18.92299652099609 43.3170166015625 8.999997138977051 31.12000274658203 8.999997138977051 C 18.92298889160156 8.999997138977051 9.000002861022949 18.92299652099609 9.000002861022949 31.12001037597656 C 9.000002861022949 43.31700897216797 18.92298889160156 53.23999786376953 31.12000274658203 53.23999786376953 M 31.12000274658203 59.23999786376953 C 15.58974933624268 59.23999786376953 3.000002861022949 46.65024948120117 3.000002861022949 31.12001037597656 C 3.000002861022949 15.58975696563721 15.58976268768311 2.999997138977051 31.12000274658203 2.999997138977051 C 46.6502571105957 2.999997138977051 59.2400016784668 15.58975696563721 59.2400016784668 31.12001037597656 C 59.2400016784668 46.65024948120117 46.6502571105957 59.23999786376953 31.12000274658203 59.23999786376953 Z M 59.2400016784668 31.12001037597656 C 59.2400016784668 31.11999702453613 59.2400016784668 31.11999702453613 59.2400016784668 31.11999702453613 L 59.2400016784668 31.12001037597656 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_62574",
    "data-name": "Path 62574",
    d: "M12,21a15.358,15.358,0,0,0,21.706,0",
    transform: "translate(8.267 19.684)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62575",
    "data-name": "Path 62575",
    d: "M13.5,13.5h.024",
    transform: "translate(9.185 9.184)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62576",
    "data-name": "Path 62576",
    d: "M22.5,13.5h.024",
    transform: "translate(17.058 9.184)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace5Stars);
export default __webpack_public_path__ + "static/media/face-5-stars.74ce9cd1540ce63417385432642d7458.svg";
export { ForwardRef as ReactComponent };